module.exports = __webpack_public_path__ + "img/mb_product_bg.1875f41.webp";